// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"4ddc3bab","647":"9dc77e72"}[chunkId] + ".chunk.js";
};